import previewImg from '../assets/preview.png';

export default function Hero({ onTalkClick }) {
  const highlightStats = [
    { label: 'Avg. CPL', value: '-48%' },
    { label: 'Launch speed', value: '14 days' },
    { label: 'Lead lift', value: '+178%' },
  ];

  return (
    <header className="relative w-full bg-gradient-to-br from-white via-sky-50 to-indigo-100 pt-32 pb-16 lg:pt-36 lg:pb-20">
      <svg
        className="pointer-events-none absolute -top-20 -right-16 h-80 w-80 blur-2xl opacity-40"
        viewBox="0 0 200 200"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#2563EB" />
            <stop offset="100%" stopColor="#7C3AED" />
          </linearGradient>
        </defs>
        <path
          fill="url(#g)"
          d="M46.5,-61.1C61.4,-56.3,75.5,-42.1,83.7,-24.4C91.9,-6.8,94.2,14.3,86.9,31C79.6,47.7,62.6,59.9,45.9,68.6C29.2,77.2,12.6,82.3,-3.8,86.8C-20.2,91.3,-40.4,95.1,-57.3,87.3C-74.2,79.4,-87.7,59.8,-90,40.1C-92.4,20.4,-83.6,0.8,-74.3,-16.3C-65,-33.4,-55.2,-47.1,-42.3,-52.7C-29.4,-58.4,-14.7,-55.9,0.3,-56.4C15.2,-56.9,30.4,-60.3,46.5,-61.1Z"
          transform="translate(100 100)"
        />
      </svg>

      <div className="relative z-10 mx-auto grid max-w-6xl grid-cols-1 items-center gap-10 px-5 sm:px-6 md:grid-cols-2">
        <div className="space-y-6">
          <p className="text-xs uppercase tracking-[0.25em] text-slate-500">Websites • Ads • Email • Social</p>
          <h1 className="text-4xl font-semibold leading-tight text-slate-900 md:text-6xl">
            We build the online engine that books you more clients.
          </h1>
          <p className="max-w-xl text-lg text-slate-600">
            Our team rebuilds your site, runs Google & Meta ads, and sets up follow-up emails so every click has a clear
            path to a sale. You see simple scorecards every week.
          </p>
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
            <button
              onClick={onTalkClick}
              className="inline-flex items-center justify-center rounded-full bg-slate-900 px-6 py-3 text-sm font-semibold text-white shadow hover:opacity-90"
            >
              Book a growth session →
            </button>
            <a
              href="#work"
              className="inline-flex items-center justify-center rounded-full border border-slate-300 px-6 py-3 text-sm font-semibold text-slate-800 hover:bg-white"
            >
              Browse wins
            </a>
          </div>
          <div className="grid gap-3 sm:grid-cols-3">
            {highlightStats.map((stat) => (
              <div key={stat.label} className="rounded-2xl border border-slate-200 bg-white/70 px-4 py-3 text-center shadow-sm">
                <p className="text-xs uppercase tracking-[0.2em] text-slate-500">{stat.label}</p>
                <p className="mt-1 text-xl font-semibold text-slate-900">{stat.value}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="relative">
          <div className="relative rounded-3xl bg-white p-4 shadow-xl ring-1 ring-slate-200">
            <img
              src={previewImg}
              alt="Anorc work preview"
              className="rounded-2xl"
            />
          </div>
        </div>
      </div>
    </header>
  );
}
